import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ActionsCloseRegularIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M20.437 20.997c-.149 0-.292-.059-.397-.165L12 12.794l-8.04 8.038c-.104.107-.248.166-.397.166-.15 0-.293-.06-.397-.166-.22-.22-.22-.575 0-.795l8.04-8.039-8.04-8.038C3.059 3.855 3 3.713 3 3.563c0-.15.058-.292.165-.397.105-.107.247-.165.397-.165.15 0 .292.058.398.165L12 11.203l8.039-8.038c.105-.107.248-.167.397-.167.15 0 .293.06.398.167.106.105.166.248.166.398 0 .15-.06.292-.166.397L12.795 12l8.04 8.038c.219.22.219.576 0 .796-.106.105-.249.165-.398.164z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ActionsCloseRegularIcon = __decorateClass([
  customElement("elm-actions-close-regular-icon")
], ActionsCloseRegularIcon);
export { ActionsCloseRegularIcon };
